var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMuteVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 92,
  height: 92,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3,
  filter: "url(#mute_video_svg__a)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 46,
  cy: 40.894,
  rx: 24,
  ry: 23.881,
  fill: "#fff"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M46 35.427c0-.89-1.077-1.337-1.707-.707l-.383.383 2.09 2.09v-1.766Zm-7.095-2.779a.898.898 0 0 0-1.27 1.27l4.095 4.095H38a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3l3.293 3.293c.63.63 1.707.184 1.707-.707v-4.316l4.25 4.26a7.381 7.381 0 0 1-1.543.916c-.409.176-.707.56-.707 1.006v.06c0 .643.602 1.12 1.202.89a9.017 9.017 0 0 0 2.478-1.442l1.414 1.407a.9.9 0 0 0 1.27-1.273L46 39.743l-7.095-7.095ZM53 41.013c0 .94-.2 1.82-.54 2.64l1.51 1.51a8.916 8.916 0 0 0 1.03-4.15c0-3.84-2.415-7.117-5.801-8.407-.6-.229-1.199.248-1.199.89v.061c0 .443.294.826.702.997A7.005 7.005 0 0 1 53 41.014Zm-2.5 0a4.464 4.464 0 0 0-1.213-3.08c-.508-.539-1.287-.083-1.287.659v.601l2.45 2.45c.05-.2.05-.42.05-.63Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "mute_video_svg__a",
  x: 0.039,
  y: 0.052,
  width: 91.922,
  height: 91.684,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.98
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5183_119812"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5183_119812",
  result: "shape"
})))));
export default SvgMuteVideo;